//请自行添加语言资源
const orderQuery = {
  orderNo:'系统单号',
  customOrderNo:'订单号',
  orderUserNo:'业务员',
  serviceType:'是否维护单',
  completionDate: '成交日期',
  presentationFlag: '是否交单',
  presentationDate:'交单日期',
  marketNo: '市场编码',
  marketName: '市场',
  productName: '产品',
  customerName: '客户姓名',
  totalGroupFunds: '总团款',
  wechatDeposit: '微信定金',
  alipayDeposit: '支付宝定金',
  corporateDeposit: '对公定金',
  joiningAreasNo: '对公地接社',
  depositType: '定金收款方式',
  joiningAreasName: '对公地接社名称',
  collectionAmount: '代收金额',
  operationAreasNo: '操作地接社',
  operationAreasName: '操作地接社名称',
  settlementPrice: '结算价',
  receivables: '应收款',
  companyExpenses: '公司支出',
  areasExpenses: '地接社支出',
  expensesAreasNo: '支出地接社',
  expensesAreasName: '支出地接社名称',
  totalProfit: '总利润',
  travelDate: '行程日期',
  travelDateBegin: '行程开始日期',
  travelDateEnd: '行程结束日期',
  travelStatusNo: '行程状态编号',
  travelStatusName: '行程状态',
  customerIdCard: '身份证',
  customerTel: '手机号',
  remark: '备注',
  msg:{
  }
};
export default orderQuery



// WEBPACK FOOTER //
// ./src/page/zhubo/orderQuery/lang/orderQuery.zh.js